<app-navbar *ngIf="!isLP2()"></app-navbar>
<app-navbar-2 *ngIf="isLP2()"></app-navbar-2>

<main>
  <router-outlet></router-outlet>
</main>

<app-footer></app-footer>